import { Link } from 'react-router-dom'
import { Icon } from './Icon'

export function Breadcrumb({ trail }: { trail: { label: string; to?: string }[] }) {
  return (
    <nav
      className="mb-3 flex flex-wrap items-center gap-1 text-xs text-fg-subtle"
      aria-label="Breadcrumb"
    >
      {trail.map((crumb, index) => (
        <span key={crumb.label} className="contents">
          {index > 0 && <Icon name="chevronRight" size="0.875rem" />}
          {crumb.to ? (
            // The 44px target belongs to the link, not to the strip: reserving
            // 44px of page height for a 13px line pushes the patient's name
            // below the fold on a phone.
            <Link
              to={crumb.to}
              className="inline-flex min-h-touch items-center rounded-sm px-1 text-fg-muted no-underline hover:text-accent hover:underline"
            >
              {crumb.label}
            </Link>
          ) : (
            <span
              className="inline-flex min-h-touch items-center px-1 font-medium text-fg"
              aria-current="page"
            >
              {crumb.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  )
}
